import { ConsolidationDefinitionDTO } from "../DTO/consolidationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateConsolidationDefinitionRequest extends BasicRequest{
   
    public consolidationDefinition! : ConsolidationDefinitionDTO;
    
    constructor(){
        super();
    }
}